import React from 'react';
import styled from 'styled-components';

export interface TabData {
    path: string;
    messageId: string;
    id: string;
}

export interface TabProps {
    active: boolean;
    ariaCurrent?: React.AriaAttributes['aria-current'];
    children: React.ReactNode;
}

const TabItem = styled.li<{ active?: boolean }>`
    background: ${({ theme, active }) => (active ? theme.primaryLightest : 'transparent')};
    border-bottom: ${({ theme }) => `1px solid ${theme.gray8}`};
    border-left: ${({ theme, active }) => (active ? `3px solid ${theme.primaryMain}` : 'none')};
    color: ${({ theme, active }) => (active ? theme.primaryDark : theme.gray3)};
    text-shadow: none;
    font-size: ${({ theme }) => theme.fontSizeBody};
    border-top: ${({ active }) => (active ? '' : 'none')};
    font-weight: 600;
    padding: 16px;
    width: 100%;
`;

const Tab: React.FC<TabProps> = ({ active, ariaCurrent=true, children }) => <TabItem active={active} aria-current={active ? ariaCurrent : undefined}>{children}</TabItem>;

export { Tab };
